import { Popover } from 'antd'

function ANTDPopover({ ...props }) {
  return <Popover {...props} />
}

export default ANTDPopover
